import { render, staticRenderFns } from "./dialogEditPrevilage.vue?vue&type=template&id=1ca329c4&lang=html"
import script from "./dialogEditPrevilage.vue?vue&type=script&lang=js"
export * from "./dialogEditPrevilage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports